export default "__VITE_ASSET__CeD16WtQ__"